@if (appUpdate.showBanner()) {
	<div class="update-banner" role="alert" aria-live="polite">
		<i class="fa-solid fa-circle-up update-banner__icon" aria-hidden="true"></i>

		<div class="update-banner__text">
			<p class="update-banner__title">Dostępna jest nowa wersja aplikacji</p>
			<p class="update-banner__subtitle">Odśwież stronę, aby korzystać z najnowszej wersji.</p>
		</div>

		<div class="update-banner__actions">
			<button mat-flat-button type="button" class="update-banner__refresh" (click)="appUpdate.applyUpdate()">
				<i class="fa-solid fa-rotate-right me-2" aria-hidden="true"></i>Odśwież
			</button>
			<button
				mat-icon-button
				type="button"
				class="update-banner__close"
				aria-label="Zamknij"
				(click)="appUpdate.dismissBanner()"
			>
				<i class="fa-solid fa-xmark" aria-hidden="true"></i>
			</button>
		</div>
	</div>
}
